<template>
  <ob-modal2 :show.sync="show" :backdrop="false">
    <template slot="modal-title">
      Add Previous Comments
    </template>
    <template slot="modal-body">
      <div class="row form-group ">
        <div class="col-md-12">
          <div class="col-md-12">
            <span style="font-weight: 600; font-size: 13px;">You can add any previous comments corresponding to this task here.</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group col-md-6">
            <label>Comment by</label><span class="validation-star">*</span>
            <ob-select2 v-if="showCreatedBy" :options="options" :inModal="true" v-model.trim="commentBy" :class="{ 'ob-vuelidate_input-error': $v.commentBy.$error }" ></ob-select2>
            <span class="ob-vuelidate_error-msg" v-if="$v.commentBy.$dirty && !$v.commentBy.required">Select commented by</span>
          </div>
          <div class="form-group col-md-6">
            <label>Commented Date</label><span class="validation-star">*</span>
            <ob-date-time-picker id="commentedDate" placeholder="Select Date" :options="options1" :inputvalue="commentedDate" @updated="(v) => this. commentedDate = v" v-model.trim="commentedDate" :class="{ 'ob-vuelidate_input-error': $v.commentedDate.$error }" ></ob-date-time-picker>
            <span class="ob-vuelidate_error-msg" v-if="$v.commentedDate.$dirty && !$v.commentedDate.required">Select commented date</span>
            <!-- <span class="ob-vuelidate_error-msg" v-if="$v.commentedDate.$dirty && !$v.commentedDate.minValue">Created Date should be after the task created date</span> -->
          </div>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-md-12">
          <div class="col-md-12">
            <ob-textarea v-model.trim="title" :maxLength="1200"  placeholder="Enter Comments "  :class="{ 'ob-vuelidate_input-error': $v.title.$error }"></ob-textarea>
            <span class="ob-vuelidate_error-msg" v-if="$v.title.$dirty && !$v.title.required">Please enter comment</span>
          </div>
        </div>
      </div>
    </template>
    <template slot="modal-footer">
      <ob-button type="secondary" @click="cancel">Cancel</ob-button>
      <ob-button @click="isValid()">Save</ob-button>
    </template>
  </ob-modal2>
</template>
<script>
import { required, minLength, maxLength, requiredIf, email, alpha, minValue, maxValue } from 'vuelidate/lib/validators'
export default {
  props:["content","openModal"],
  data(){
    return{
      showCreatedBy:false,
      CreatedByList:'',
      title:'',
      show: false,
      commentBy:'',
      commentedDate:'',
      options1: {
        format: 'MM/DD/YYYY',
        dayViewHeaderFormat: 'MM/DD/YYYY',
        maxDate : moment(),
        minDate : this.content.CreatedDate,
        ignoreReadonly: true,
        widgetPositioning: {
          horizontal: 'auto',
          vertical: 'bottom'
        }
      },
      options: {
        placeholder: {
          id: "-1",
          text: "Select"
        },
        data: [
        ]
      }
    }
  },
  validations() {
    return{
      title:{
        required
      },
      commentBy:{
        required
      },
      commentedDate:{
        required,
        //minValue: (commentedDate) => moment().isAfter(this.content.CreatedDate) <= 0
      }
    }
  },
  components: {

  },
  created(){
    this.show = this.openModal
    this.resetFields()
    this.fetchCreatedByDetails()
  },
  watch:{
    showModal(val){
      this.show = val
      this.resetFields()
      if(val)
      {
        this.fetchCreatedByDetails()
      }
    },
    show(val) {
      this.$emit('update:openModal', val)
    },
  },
  computed:{
    EmployeeId() {
      return this.content.EmployeeId ? this.content.EmployeeId : this.$route.query.EmployeeId;
    },
    showModal(){
      return this.openModal
    },

  },

  methods:{
    teskCreatedDate()
    {
      if(this.show)
      {
        return this.content.CreatedDate
      }
    },
    guid() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
      }
      return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
        s4() + '-' + s4() + s4() + s4();
    },
    fetchCreatedByDetails()
    {
      this.$loading({
        'loadingText': 'Loading...'
      })
      this.showCreatedBy = false
        ajax.get(`/Task/${this.EmployeeId}/GetTaskCreatedDetails`,{},(res)=>{
        this.CreatedByList = res.data.UserDetails;
        this.options.data = __.map(res.data.UserDetails, (t) => {
          return { 'id': t.Id, 'text': t.FirstName +" "+ t.LastName  }
        })
        // if(this.options.data.length > 0){
        //     this.commentBy = this.options.data[0].id
        // }
        this.showCreatedBy = true
          this.$loading({}).close()
      })
    },
    isValid() {
      this.$v.commentBy.$touch();
      this.$v.commentedDate.$touch();
      this.$v.title.$touch();
        if(this.$v.title.$error == false && this.$v.commentBy.$error == false && this.$v.commentedDate.$error == false){
          this.$loading({
            'loadingText': 'Loading...'
          })
        this.saveComment()
        this.show = false
       }
       else{
        this.show = true
      }
    },
    saveComment(){
      var createdBySelectedIndex = this.CreatedByList.map(e => e.Id).indexOf(this.commentBy);
      this.commentBy = this.CreatedByList[createdBySelectedIndex]
      var userObj = {
        Id: this.commentBy.Id,
        FirstName : this.commentBy.FirstName,
        LastName : this.commentBy.LastName,
        Email : this.commentBy.Email,
        ProfilePicLink : this.commentBy.ProfilePicLink,
        CurrentRole: this.commentBy.CurrentRole
      }
      var Obj={
        Title:this.title,
        Type :4,
        CreatedDate:this.commentedDate,
        UserDetails: userObj
      }
      ajax.put(`Task/${this.content.TaskId}/AddResource`, Obj , res => {
        if (res.data.State == true) {
          this.$parent.$parent.$parent.fetchTaskDetails('fetchDetails')
          this.$parent.$parent.$parent.handlingLocalObject(Obj)
          this.$loading({}).close();
        }else{
          this.$loading({}).close();
          this.$message({
            type: 'error',
            message: res.data.Message
          });
        }
      })
    },
    cancel(){
      this.show = false
    },
    resetFields(){
      this.commentedDate = ''
      this.title = ''
      this.commentBy = ''
      this.$v.commentedDate.$reset();
      this.$v.title.$reset();
      this.$v.commentBy.$reset();
    }
  }
}
</script>
<style lang="scss" scoped>
  .validation-star{
    color: #F31D1D;
  }
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/Tasks/AddPreviousComment.vue